// extracted by mini-css-extract-plugin
export default {"btn":"Inverite_btn__JQVJ8","btn-success":"Inverite_btn-success__xrjTW","container":"Inverite_container__E2Efs","inverite":"Inverite_inverite__lTmsq"};